// extracted by mini-css-extract-plugin
export default {"root":"M7k9w__root","thumbnail":"BUh4b__thumbnail","timeDisplay":"NEXja__timeDisplay Z3kBD__controlRoot","chapterTitleDisplay":"Wdr71__chapterTitleDisplay Z3kBD__controlRoot"};